export const BookLeftBarStatus = Object.freeze({
  BOOKSHELF: 'bookShelf',
  TRASHCAN: 'trashCan',
})
